import {
  useSearchUsersByAppRoleFiltersQuery,
  type SearchUsersByAppRoleFiltersQueryVariables,
} from '@exam-management/graphql';
import { useMemo } from 'react';

import { mapUserList } from '../../../utils';
import { useUserList } from '../../provider';
import { BaseUserList } from '../base-user-list';
import type { OmittedUserListProps } from '../user-list';

export function UserManagementList(props: Readonly<OmittedUserListProps>) {
  const { moreColumns = [], options = {}, SelectUsersCountProps = {}, DataGridProps } = props;
  const { searchAndFilterInput, dataGridParams } = useUserList();

  const { sort, pageSize, page, field, role } = dataGridParams;

  const { search, status } = searchAndFilterInput;

  const fetchVariables = useMemo<SearchUsersByAppRoleFiltersQueryVariables>(() => {
    return {
      order: {
        field: field,
        type: sort,
      },
      paging: {
        pageSize: pageSize,
        currentPage: page,
      },
      search: {
        firstname: search,
        lastname: search,
        email: search,
        status: status,
      },
      appRoleNames: role ? [role] : [],
    };
  }, [searchAndFilterInput, dataGridParams]);

  const {
    data,
    loading: isLoading,
    error,
  } = useSearchUsersByAppRoleFiltersQuery({ variables: fetchVariables });

  const users = useMemo(() => {
    if (data?.UsBoSearchUsersWithAppRoleFilters) {
      return mapUserList(data?.UsBoSearchUsersWithAppRoleFilters.users);
    }
    return [];
  }, [data]);

  const totalCount = data?.UsBoSearchUsersWithAppRoleFilters?.total ?? 0;

  const dataGridProps = {
    ...DataGridProps,
    moreColumns,
    totalCount,
    isLoading,
    rows: users,
    error,
  };

  return (
    <BaseUserList
      options={options}
      dataGridProps={dataGridProps}
      selectUsersCountProps={SelectUsersCountProps}
    />
  );
}
